import { SimplePage } from "@/app/_/marketing/SimplePage";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Help Center"
      title="How can we help?"
      subtitle="Guides, walkthroughs, and best practices for getting the most out of Neoledger."
      primaryCta={{
        label: "Contact support",
        to: "/company/contact",
      }}
      secondaryCta={{
        label: "Join waitlist",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
    />
  );
}
